import React from "react";
import { AppProvider } from "@context/AppContext";

import GTM from "@utils/GTM";

import "./src/styles/global.css";
import "./src/styles/cookies.css";
import "./src/styles/access-reimbursement.css";
import "./src/styles/efficacy.css";
import "./src/styles/efficacy-anesthesia.css";
import "./src/styles/pediatric-surgery.css";
import "./src/styles/obstetrics-gynecologic-surgery.css";
import "./src/styles/dosing.css";
import "./src/styles/orthopedic-surgery.css";
import "./src/styles/oral-maxillofacial-surgery.css";
import "./src/styles/resources.css";
import "./src/styles/homepage.css";
import "./src/styles/risk-of-opiods.css";
import "./src/styles/why-exparel.css";
import "./src/styles/safety.css";
import "./src/styles/colorectal-surgery.css";
import "./src/styles/hip-surgery.css";
import "./src/styles/plastic-surgery.css";
import "./src/styles/sitemap.css";

export const onRouteUpdate = () => {
  GTM.pageView();
  GTM.trackCTA();
};

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
);
